import configs from 'shared/constants/configs';
import { mainRoutes } from 'shared/constants/routes';

export type ProviderParams = {
	rememberMe?: boolean;
};

export enum ProviderPath {
	GOOGLE = 'google',
}

function getNextPage() {
	const pathname = window.location.pathname.slice(1).split('/')[0];
	if (pathname) {
		const found = Object.values(mainRoutes).find((route) => route.path.slice(1).split('/')[0] === pathname);
		if (found) {
			return window.location.href;
		}
	}
	return '';
}

export function getSsoUrlParams(providerPath: ProviderPath, params?: ProviderParams) {
	const url = new URL(`${window.location.origin}/oauth`);
	Object.entries(params ?? {}).forEach(([key, value]) => {
		if (([null, undefined, '', false] as unknown[]).includes(value)) return;
		url.searchParams.set(key, `${value}`);
	});

	const nextPage = getNextPage();
	if (nextPage) {
		url.searchParams.set('next', nextPage);
	}

	const ssoUrl = new URL(`${configs.backendApiUri}/auth/${providerPath}`);
	ssoUrl.searchParams.set('state', url.toString());
	return ssoUrl.toString();
}
